import { formatEventDate } from '../../../shared/formattingUtils';

// Order source groups for the "Ticket source" filter. Keys map to Orderable
// manual_types on the backend (VenueScope::SOURCE_GROUP_MANUAL_TYPES). Selecting one
// or more shows only those sources; selecting none (default) shows everything.
export const TICKET_SOURCE_OPTIONS = [
  { value: 'direct', label: 'Opendate Direct' },
  { value: 'external_import', label: 'External Imported' },
  { value: 'opendate_distribution', label: 'Opendate Distribution' },
];

export const buildSalesFilterGroups = (venueOwnerships = [], eventOptions = [], tagOptions = [], { includeSources = false, sellerOptions = [] } = {}) => {
  const groups = [
    {
      id: 'venue',
      label: 'Venue',
      filters: [
        {
          id: 'venue_ownership_id',
          label: 'Venue',
          type: 'checkbox',
          options: venueOwnerships.map(vo => ({
            value: String(vo.id),
            label: vo.name,
          })),
        },
      ],
    },
    {
      id: 'event',
      label: 'Event',
      filters: [
        {
          id: 'calendar_event_id',
          label: 'Event Name',
          type: 'search',
          options: eventOptions.map(e => ({
            value: String(e.id),
            label: e.event_date ? `${e.name} \u00B7 ${formatEventDate(e.event_date)}` : e.name,
          })),
        },
      ],
    },
    {
      id: 'payment',
      label: 'Payment Type',
      filters: [
        {
          id: 'payment_type',
          label: 'Payment Type',
          type: 'checkbox',
          options: [
            { value: 'cash', label: 'Cash' },
            { value: 'card', label: 'Card' },
          ],
        },
      ],
    },
  ];

  if (tagOptions.length > 0) {
    groups.push({
      id: 'tag',
      label: 'Tag',
      filters: [
        {
          id: 'tag_ids',
          label: 'Tag',
          type: 'checkbox',
          options: tagOptions.map(t => ({
            value: String(t.id),
            label: t.name,
          })),
        },
      ],
    });
  }

  if (sellerOptions.length > 0) {
    groups.push({
      id: 'sold_by',
      label: 'Sold By',
      filters: [
        {
          id: 'team_membership_id',
          label: 'Sold By',
          type: 'search',
          options: sellerOptions.map(s => ({
            value: String(s.id),
            label: s.name,
          })),
        },
      ],
    });
  }

  if (includeSources) {
    groups.push({
      id: 'ticket_source',
      label: 'Ticket Source',
      filters: [
        {
          id: 'sources',
          label: 'Ticket source',
          type: 'checkbox',
          options: TICKET_SOURCE_OPTIONS,
        },
      ],
    });
  }

  return groups;
};

export const withRoomFilterGroup = (groups, roomOptions = []) => {
  if (roomOptions.length < 2) return groups;

  const roomGroup = {
    id: 'room',
    label: 'Room',
    filters: [
      {
        id: 'room_ids',
        label: 'Room',
        type: 'checkbox',
        options: roomOptions.map(r => ({
          value: String(r.id),
          label: r.name,
        })),
      },
    ],
  };
  let index = groups.findIndex(g => g.id === 'event');
  if (index === -1) index = groups.findIndex(g => g.id === 'venue');
  if (index === -1) return [...groups, roomGroup];
  return [...groups.slice(0, index + 1), roomGroup, ...groups.slice(index + 1)];
};
